import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

function ValidatedNumberInput({ value, onChange }) {
  return (
    <TextField
      variant="outlined"
      value={value}
      margin="dense"
      type="number"
      InputProps={{ inputProps: { min: 0 } }}
      onInput={(e) => {
        e.target.value = e.target.value.replace(/\D/g, '');
      }}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

ValidatedNumberInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ValidatedNumberInput;
